module.exports = new __parcel__URL__("shop_special_items_button.1dbd802a.png").toString();